import { ChangeEvent, Dispatch, FC, FocusEvent, SetStateAction } from 'react';
import { Autocomplete, TextFieldProps } from '@mui/material';

import { TextField } from './TextField';

export type MultipleFreeSoloProps = Pick<
  TextFieldProps,
  'color' | 'error' | 'focused' | 'helperText' | 'label' | 'margin' | 'required'
> & {
  setValues: Dispatch<SetStateAction<string[]>>;
  values: string[];
};

export const MultipleFreeSolo: FC<MultipleFreeSoloProps> = ({
  label,
  values,
  setValues,
  required,
  ...rest
}) => (
  <Autocomplete
    aria-required={required}
    freeSolo
    multiple
    onChange={(_, value) => setValues(value)}
    options={[]}
    renderInput={({ inputProps: { onChange, onBlur, ...inputProps }, ...params }) => (
      <TextField
        {...params}
        {...rest}
        label={label}
        onBlur={(e: FocusEvent<HTMLInputElement>) => {
          const {
            currentTarget: { value },
          } = e;

          if (value && !values.includes(value.trim()))
            setValues(prev => [...(prev || []), value.trim()]);

          const event = { ...e, target: { ...e.target, value: '' } };
          onChange?.(event);
          onBlur?.(event);
        }}
        required={required}
        slotProps={{
          htmlInput: {
            ...inputProps,
            onChange: (e: ChangeEvent<HTMLInputElement>) => {
              const {
                currentTarget: { value },
              } = e;

              if (value.endsWith(' ') && !values.includes(value.trim())) {
                setValues(prev => [...(prev || []), value.trim()]);
                onChange?.({ ...e, target: { ...e.target, value: '' } });
              } else onChange?.({ ...e, target: { ...e.target, value } });
            },
          },
        }}
      />
    )}
    value={values}
  />
);
